import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicCircleTransferSelected({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 56 56"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <g fill="none" fillRule="evenodd">
        <circle fill="#56A" opacity={0.88} cx={28} cy={28} r={28} />
        <g transform="translate(16.5 20)">
          <rect fill="#8F9DD6" x={5} y={5} width={18} height={12} rx={1} />
          <rect fill="#FFF" width={18} height={12} rx={1} />
        </g>
        <path
          d="M40.26 16.72l2.2-1.98-.6 4.55C39.77 15.09 36.3 13 31.5 13"
          stroke="#FFF"
          strokeWidth={1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path fill="#FFF" d="M40.5 16h2v2h-2z" />
        <path
          d="M15.9 39.93l-2.34 1.61.58-4.54c2.1 4.2 5.58 6.29 10.37 6.29"
          stroke="#8F9DD6"
          strokeWidth={1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path fill="#8F9DD6" d="M13.5 38.33h2v2h-2z" />
      </g>
    </svg>
  );
}

SvgPicCircleTransferSelected.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicCircleTransferSelected.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicCircleTransferSelected svgRef={ref} {...props} />
));
export default ForwardRef;
